module.exports = __webpack_public_path__ + "static/media/ndi-hero.f7aef4ca.jpg";